
// リンクコピーボタン
const linkCopyBtns = document.querySelectorAll('.link-copy-button');
console.log('linkCopyBtns',linkCopyBtns);
// リンクコピー時に表示するテキスト
const linkCopyTexts = document.querySelectorAll('.link-copy-text');
// 現在のURL
const currentUrl = window.location.href;

// リンクコピー時テキスト表示関数
function showTooltip() {
  linkCopyTexts.forEach((linkCopyText) => {
  linkCopyText.style.visibility = 'visible'
  linkCopyText.style.opacity = 1
  // 2秒後にテキスト非表示関数を呼び出し
  setTimeout(hideTooltip, 2000);
  })
}
// リンクコピー時テキスト非表示関数
function hideTooltip() {
  linkCopyTexts.forEach((linkCopyText) => {
    linkCopyText.style.opacity = '0';
    setTimeout(() => {
      linkCopyText.style.visibility = 'hidden'
    }, 500);
  })
}
// リンクコピーボタンクリック時
linkCopyBtns.forEach((linkCopyBtn) => {
  console.log('linkCopyBtn',linkCopyBtn);
  linkCopyBtn.addEventListener('click', () => {
    // 現在のURLをクリップボードにコピー
    navigator.clipboard.writeText(currentUrl);
    // テキスト表示
    showTooltip();
  });
});
